var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioCallUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_33910",
    "data-name": "Group 33910",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13713",
    "data-name": "Rectangle 13713",
    width: 18,
    height: 18,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M889.846,399.611c3.245,3.244,3.981-.508,6.047,1.556,1.991,1.991,3.136,2.39.612,4.913-.316.254-2.324,3.31-9.381-3.746s-4-9.068-3.751-9.383c2.53-2.53,2.922-1.379,4.913.612C890.352,395.629,886.6,396.367,889.846,399.611Z",
    transform: "translate(-881.213 -390.212)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioCallUsage);
export default __webpack_public_path__ + "static/media/audio-call-usage.2384fc31.svg";
export { ForwardRef as ReactComponent };